import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/hr-theme.css';
import 'react-toastify/dist/ReactToastify.css';
import setupAuthenticatedFetch from './utils/setupAuthenticatedFetch';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';


let initialStore = {
  loginDetails:{}
}

let reducer =(latestStore = initialStore,dispatchedObj)=>{
console.log("inside Reducer");
  if (dispatchedObj.type === "login") {
    return{...latestStore,loginDetails:dispatchedObj.data};
  }


  return latestStore;
}

let store = createStore(reducer);
setupAuthenticatedFetch();
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
    <Provider store={store}>
    <App />
    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop
      theme="colored"
      className="hr-toast-container"
    />
    </Provider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
